import { useCallback, useMemo, useState } from 'react';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import {
  setAnswer,
  type AnswerOption,
} from '@/modules/simulado/domain/entities/answer.entity';
import {
  GabaritoDraftStore,
  type GabaritoDraft,
} from '../../data/datasources/gabarito-draft.store';

/** O gabarito em preenchimento desta prova e edição, gravado a cada mudança. */
export function useGabaritoDraft() {
  const { id, edition } = useTenant();
  const store = useMemo(
    () => new GabaritoDraftStore(id, edition.year),
    [id, edition.year],
  );
  const [draft, setDraft] = useState<GabaritoDraft>(() => store.read());

  const update = useCallback(
    (next: GabaritoDraft) => {
      store.save(next);
      setDraft(next);
    },
    [store],
  );

  return {
    draft,
    setAnswer: (question: number, answer: AnswerOption | null) =>
      update({ ...draft, answers: setAnswer(draft.answers, question, answer) }),
    clear: () => {
      store.clear();
      setDraft({ answers: {} });
    },
  };
}
